import I18nUtil from '@didi/i18n-util';
import env from '@/config/env';

export const getLocale = () => {
  const { getLocale } = I18nUtil;
  let locale = getLocale();
  locale = devAutoChangeLocale(locale);
  return locale;
};

export const getLanguageLong = () => {
  const { getLanguageLong } = I18nUtil;
  let lang = getLanguageLong();
  lang = devAutoChangeLocale(lang);
  return lang;
};

// 为了本地和sim环境能够自动跳转到es—MX 特殊处理
function devAutoChangeLocale(lang) {
  if (env.isSim || env.isDev) {
    let urlLocale = location.pathname.split('/')[1];
    !urlLocale && (lang = lang === 'zh-CN' ? 'es-MX' : lang);
  }
  return lang;
}
